import { siteConfig } from './site.config'

/**
 * App configuration — what this site needs from the Upbo platform.
 *
 * The important line is `ownerEmails`. This is a SINGLE-BOUTIQUE site: visitors
 * browse and enquire without an account, and exactly one account — the shop
 * owner — can reach /studio to post and manage listings.
 */
export const appConfig = {
  authMode: 'optional' as 'required' | 'optional' | 'none',
  authProviders: ['email'] as ('email' | 'google' | 'facebook' | 'github' | 'otp')[],
  protectedScope: 'partial' as 'all' | 'partial',
  /** Routes behind the owner gate — RequireOwner reads this list. */
  protectedRoutes: ['/studio', '/studio/listings', '/studio/new'],
  userDataMode: 'both' as 'none' | 'per-user' | 'both',
  userRoles: ['owner', 'visitor'] as string[],

  /**
   * THE OWNER ACCOUNT. `VITE_OWNER_EMAIL` wins when it is set (that is what the
   * publish flow injects); otherwise this list applies. Add a second address
   * here to give a manager the same access.
   */
  ownerEmails: ['owner@tempora.watch'],

  defaultTheme: 'light',
  appName: siteConfig.name,
  appDescription: siteConfig.description.en,
  appVersion: '1.0.0',

  features: {
    darkModeToggle: true,
    languageSwitcher: true,
    enquiries: true,
    ownerStudio: true,
  },
}

export type AppConfig = typeof appConfig

/** The single owner address in force right now (env first, config second). */
export const OWNER_EMAILS: string[] = (() => {
  const fromEnv = (import.meta.env.VITE_OWNER_EMAIL as string | undefined)?.trim()
  return (fromEnv ? [fromEnv] : appConfig.ownerEmails).map((e) => e.toLowerCase())
})()
